import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import journalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import threeMonthsGoalsJournalEvent from 'parog-web/models/three-months-goals-journal-event';
export default class GoalsEditionComponent extends ForcJournalEventBasedComponent {
  static override forcDisplayName = 'Objectifs à 3 mois';
  static override fullComponentId = 'lifestyle/goals-edition-form';
  static override journalEventClass = threeMonthsGoalsJournalEvent;

  @service declare intl: IntlService;

  override journalEventProperties = ['goals', 'occurredAt'];
  override retrieveJournalEvent =
    journalEventRetrievalStrategies.sourceJournalEvent;

  override get validations(): Record<string, unknown> {
    return this.journalEventClass.validations(this.intl);
  }

  override retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (this.isNewMode) model.occurredAt = new Date();
    return model;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <div class='field'>
          <Form.Date @labelName='Date' @propertyName='occurredAt' />
        </div>
        <div class='field'>
          <Form.TextArea
            data-test-goals-message
            @labelName='Objectifs'
            @subText='Ces informations sont partagées avec le patient.'
            @displaySubText={{true}}
            @propertyName='goals'
            @rows={{5}}
          />
        </div>
      </:content>
    </Provider>
  </template>
}
